<template>
  <div class="ws-infinite-layers">
    <div
      v-for="(valueItem, valueIndex) in value"
      :key="$_getKey(valueItem)"
    >
      <component
        :is="_currentLayer.component"
        :value="valueItem.state"
        v-bind="_currentLayer.props"
        :parentModelData="parentModelData"
        :modelName="modelName"
        :editType="editType"
        :deletable="_deletable"
        @input="$_onStateInput($event,valueIndex)"
        @delete="$_onDelete(valueIndex)"
      ></component>
      <div
        class="ml-10"
        v-if="valueItem.items"
      >
        <WsInfiniteLayers2
          :layers="_itemLayers"
          :value="valueItem.items"
          :modelName="modelName"
          :editType="editType"
          :parentModelData="parentModelData"
          @input="$_onInfiniteLayersInput($event,valueIndex)"
        ></WsInfiniteLayers2>
      </div>
      <div>
        <WsBtn
          class="ws-infinite-layers__btn"
          @click="$_onAddFirstLayerAllValue(valueIndex+1)"
          minWidth="100px"
          :color="_currentLayer.btnAddColor"
          :outlined="_currentLayer.btnAddOutline"
        >
          <v-icon
            left
            v-if="_currentLayer.btnAddIcon"
          >{{_currentLayer.btnAddIcon}}</v-icon>{{_currentLayer.btnAddText}}
        </WsBtn>
      </div>
    </div>
    <div v-if="!value.length">
      <WsBtn
        class="ws-infinite-layers__btn"
        @click="$_onAddFirstLayerAllValue(0)"
        minWidth="100px"
        :color="_currentLayer.btnAddColor"
        :outlined="_currentLayer.btnAddOutline"
      >
        <v-icon
          left
          v-if="_currentLayer.btnAddIcon"
        >{{_currentLayer.btnAddIcon}}</v-icon>{{_currentLayer.btnAddText}}
      </WsBtn>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    $_onStateInput($event, valueIndex) {
      const _value = [...this.value];
      _value[valueIndex].state = { ...$event };
      this.$emit("input", _value);
    },
    $_onInfiniteLayersInput($event, valueIndex) {
      const _value = [...this.value];
      _value[valueIndex].items = [...$event];
      this.$emit("input", _value);
    },
    $_onAddFirstLayerAllValue(index) {
      let firstLayerAllValue = {};
      let nestValue;
      nestValue = firstLayerAllValue;
      this.layers.forEach((layer, layerIndex) => {
        nestValue.state = {};
        if (layerIndex < this.layers.length - 1) {
          nestValue.items = [{}];
          nestValue = nestValue.items[0];
        }
      });
      if (this.editType === "createVersion") {
        firstLayerAllValue.state.isNew = true;
      }
      const _value = [...this.value];
      _value.splice(index, 0, firstLayerAllValue);
      this.$emit("input", _value);
    },
    $_onDelete(valueIndex) {
      const _value = [...this.value];
      _value.splice(valueIndex, 1);
      this.$emit("input", _value);
    },
    $_getKey(valueItem) {
      if (!valueItem.state.id && !valueItem.state.fakeId) {
        let date = new Date();
        const _fakeKey = `${date.getMonth()}${date.getDate()}${date.getMinutes()}${Math.random()
          .toString(36)
          .substring(10)}`;
        valueItem.state.fakeId = _fakeKey;
      }
      return valueItem.state.id || valueItem.state.fakeId;
    },
  },
  computed: {
    _btnAddText() {
      if (this._currentLayer.btnAddText) {
        return this._currentLayer.btnAddText;
      } else {
        return "新增";
      }
    },
    _currentLayer() {
      return this.layers[0];
    },
    _itemLayers() {
      const _layers = [...this.layers];
      const _itemLayers = _layers.splice(1, _layers.length);
      return _itemLayers;
    },
    _deletable() {
      if (this.value.length > 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  props: {
    value: {
      type: Array,
    },
    layers: {
      type: Array,
    },
    modelName: {
      type: String,
    },
    parentModelData: {
      type: Object,
    },
    editType: {
      type: String,
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/ws-infinite-layers";
</style>